import { render } from "./EconomyStatusGlobalPrices.vue?vue&type=template&id=59658bcc&ts=true"
import script from "./EconomyStatusGlobalPrices.vue?vue&type=script&lang=ts"
export * from "./EconomyStatusGlobalPrices.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__